export const colorsSets = [
  {
    label: "Plotly",
    value: [
      "#636EFA",
      "#EF553B",
      "#00CC96",
      "#AB63FA",
      "#FFA15A",
      "#19D3F3",
      "#FF6692",
      "#B6E880",
      "#FF97FF",
      "#FECB52",
    ],
  },
  {
    label: "D3",
    value: [
      "#1F77B4",
      "#FF7F0E",
      "#2CA02C",
      "#D62728",
      "#9467BD",
      "#8C564B",
      "#E377C2",
      "#7F7F7F",
      "#BCBD22",
      "#17BECF",
    ],
  },
  {
    label: "G1",
    value: [
      "#3366CC",
      "#DC3912",
      "#FF9900",
      "#109618",
      "#990099",
      "#0099C6",
      "#DD4477",
      "#66AA00",
      "#B82E2E",
      "#316395",
    ],
  },
  {
    label: "T10",
    value: [
      "#4C78A8",
      "#F58518",
      "#E45756",
      "#72B7B2",
      "#54A24B",
      "EECA3B",
      "#B279A2",
      "#FF9DA6",
      "#9D755D",
      "#BAB0AC",
    ],
  },
  {
    label: "Alphabet",
    value: [
      "#AA0DFE",
      "#3283FE",
      "#85660D",
      "#728AB6",
      "#565656",
      "#1C8356",
      "#16FF32",
      "#E7E1A0",
      "#E2E2E2",
      "#1CBE4F",
      "#C4451C",
      "#DEA0FD",
      "#FE00FA",
      "#325A9B",
      "#FEAF16",
      "#F8A19F",
      "#90AD1C",
      "#F6222E",
      "#1CFFCE",
      "#2ED9FF",
      "#B10DA1",
      "#C075A6",
      "#FC1C8F",
      "#B00068",
      "#FBE426",
      "#FA0087",
    ],
  },
  {
    label: "Dark24",
    value: [
      "#2E91E5",
      "#E15F99",
      "#1CA71C",
      "#FB0D0D",
      "#DA16FF",
      "#222A2A",
      "#B68100",
      "#750D86",
      "#EB663B",
      "#511CFB",
      "#00A08B",
      "#FB00D1",
      "#FC0080",
      "#B2828D",
      "#6C7C32",
      "#778AAE",
      "#862A16",
      "#A777F1",
      "#620042",
      "#1616A7",
      "#DA60CA",
      "#6C4516",
      "#0D2A63",
      "#AF0038",
    ],
  },
  {
    label: "Light24",
    value: [
      "#FD3216",
      "#00FE35",
      "#6A76FC",
      "#FED4C4",
      "#FE00CE",
      "#0DF9FF",
      "#F6F926",
      "#FF9616",
      "#479B55",
      "#EEA6FB",
      "#DC587D",
      "#D626FF",
      "#6E899C",
      "#00B5F7",
      "#B68E00",
      "#C9FBE5",
      "#FF0092",
      "#22FFA7",
      "#E3EE9E",
      "#86CE00",
      "#BC7196",
      "#7E7DCD",
      "#FC6955",
      "#E48F72",
    ],
  },
  {
    label: "Set1",
    value: [
      "#E41A1C",
      "#377EB8",
      "#4DAF4A",
      "#984EA3",
      "#FF7F00",
      "#FFFF33",
      "#A65628",
      "#F781BF",
      "#999999",
    ],
  },
  {
    label: "Pastel1",
    value: [
      "#FBB4AE",
      "#B3CDE3",
      "#CCEBC5",
      "#DECBE4",
      "#FED9A6",
      "#FFFFCC",
      "#E5D8BD",
      "#FDDAEC",
      "#F2F2F2",
    ],
  },
  {
    label: "Dark2",
    value: ["#1B9E77", "#D95F02", "#7570B3", "#E7298A", "#66A61E", "#E6AB02", "#A6761D", "#666666"],
  },
  {
    label: "Set2",
    value: ["#66C2A5", "#FC8D62", "#8DA0CB", "#E78AC3", "#A6D854", "#FFD92F", "#E5C494", "#B3B3B3"],
  },
  {
    label: "Pastel2",
    value: ["#B3E2CD", "#FDCDAC", "#CBD5E8", "#F4CAE4", "#E6F5C9", "#FFF2AE", "#F1E2CC", "#CCCCCC"],
  },
  {
    label: "Set3",
    value: [
      "#8DD3C7",
      "#FFFFB3",
      "#BEBADA",
      "#FB8072",
      "#80B1D3",
      "#FDB462",
      "#B3DE69",
      "#FCCDE5",
      "#D9D9D9",
      "#BC80BD",
      "#CCEBC5",
      "#FFED6F",
    ],
  },
  {
    label: "Antique",
    value: [
      "#8C564B",
      "#E377C2",
      "#7F7F7F",
      "#BCBD22",
      "#17BECF",
      "#393B79",
      "#637939",
      "#8C6D31",
      "#843C39",
      "#7B4173",
    ],
  },
  {
    label: "Bold",
    value: [
      "#FF0000",
      "#FF4500",
      "#32CD32",
      "#1E90FF",
      "#FFD700",
      "#8A2BE2",
      "#00CED1",
      "#FF1493",
      "#8B0000",
      "#00FF00",
      "#4682B4",
      "#FF6347",
      "#2E8B57",
      "#9400D3",
      "#FF69B4",
      "#8B008B",
      "#FFA07A",
      "#7CFC00",
      "#00BFFF",
      "#FFB6C1",
    ],
  },
  {
    label: "Pastel",
    value: [
      "#FFD1DC",
      "#FFE4E1",
      "#D8BFD8",
      "#E6E6FA",
      "#FFF0F5",
      "#F5DEB3",
      "#FFEFD5",
      "#F0FFF0",
      "#F0FFFF",
      "#FFFACD",
    ],
  },
  {
    label: "Prism",
    value: [
      "#FF6347",
      "#FFD700",
      "#ADFF2F",
      "#00FA9A",
      "#00CED1",
      "#4682B4",
      "#4169E1",
      "#8A2BE2",
      "#C71585",
      "#FF4500",
      "#DA70D6",
      "#EEE8AA",
      "#98FB98",
      "#AFEEEE",
      "#DB7093",
      "#FF00FF",
    ],
  },
  {
    label: "Safe",
    value: [
      "#E6194B",
      "#3CB44B",
      "#FFE119",
      "#0082C8",
      "#F58231",
      "#911EB4",
      "#46F0F0",
      "#F032E6",
      "#D2F53C",
      "#008080",
      "#AA6E28",
      "#800000",
      "#AAFFC3",
      "#808000",
      "#000080",
      "#808080",
    ],
  },
  {
    label: "Vivid",
    value: [
      "#E41A1C",
      "#377EB8",
      "#4DAF4A",
      "#984EA3",
      "#FF7F00",
      "#FFFF33",
      "#A65628",
      "#F781BF",
      "#999999",
      "#FBB4AE",
      "#B3CDE3",
      "#CCEBC5",
      "#DECBE4",
      "#FED9A6",
      "#FFFFCC",
      "#E5D8BD",
      "#FDDAEC",
      "#F2F2F2",
    ],
  },
];
